import { useProductsQuery } from './useProductsQuery';
import { useProductsSearch } from './useProductsSearch';

export const useProducts = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useProductsQuery(filters);
    const { keyword } = useProductsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.name?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.description?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
    };
};
